import {AddKpiCard, KpiCard} from "../card/KpiCard";
import "../../dashboard/DashboardLayout.css"
import './KpiDashboard.css'
import {useEffect, useState} from "react";
import {getKpiStatus, updateKpiInfo} from "../../../services/kpiService";
import {useAuth} from "../../../providers/AuthProvider";
import {CommonComponentState, KpiInfo, KpiStatus} from "../../../types/types";
import {DashboardOverView} from "../overview/dashboardOverView";
import {ErrorPage} from "../../error/ErrorPage";
import {Loader} from "../../loader/Loader";
import {EnvironmentRegistry} from "../../../services/registry/environmentRegistry";
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowUpRightFromSquare,
    faBan,
    faChartLine,
    faChartSimple,
    faCircleExclamation,
    faShare,
    faSquareCheck,
} from "@fortawesome/free-solid-svg-icons";
import {Button, Modal} from "@mantine/core";
import {CloneKpi} from "../card/CloneKpi";
import {DashboardStatCard} from "../overview/dashboardStatCard";

export interface KpiDashboardState extends CommonComponentState {
    kpiStatus: KpiStatus,
    isSelectable: boolean
}


export function KPIDashboard() {

    const [state, setState] = useState<KpiDashboardState>({loading: true, kpiStatus: {} as any, isSelectable: false});

    const [openCloneModal, setOpenCloneModal] = useState(false)

    const authContext = localStorage.getItem("authContext")? JSON.parse(localStorage.getItem("authContext") ?? "{}"): {};

    async function changeStatus(enabled: boolean, kpiInfo: KpiInfo) {
        if (state.loading) {
            return;
        }
        const currentStatus = {...state.kpiStatus};
        const info = currentStatus.contents.filter(info => info.kpiInfo.name === kpiInfo.name)[0]
        info.kpiInfo.activeStatus = enabled ? "active" : "inactive"
        currentStatus.activeKpis = currentStatus.activeKpis + (enabled ? +1 : -1);
        currentStatus.inactiveKpis = currentStatus.inactiveKpis + (enabled ? -1 : +1);
        await updateKpiInfo(info.kpiInfo, authContext)
        setState({...state, kpiStatus: currentStatus});
    }

    const getData = async () => {
        try {
            const kpiStatus = await getKpiStatus(authContext)
            console.log(kpiStatus)
            setState({kpiStatus, loading: false, isSelectable: false});
        } catch (error) {
            console.log(error)
            const message = (error as any).message
            setState({...state, error: message, loading: false})
        }
    }
    useEffect(() => {
        getData()
        // eslint-disable-next-line
    }, []);

    const enableSelections = () => {
        setState(currentState => {
            const newState = {...currentState, isSelectable: true}
            newState.kpiStatus.contents = newState.kpiStatus.contents.map(info => ({...info, isSelected: false}))
            return newState;
        })
    }

    async function DeleteKPI(kpiId: string) {
        setState({...state, loading: true});
        console.log("delete ", kpiId);
        const url = EnvironmentRegistry.getUrlFromContext(authContext);
        await axios.delete(`${url}/v1/kpi/info/${kpiId}`, {
            headers: EnvironmentRegistry.makeAuthHeadersFromContext(authContext)
        })
        getData();
    }

    const selectKpi = (name: string) => {
        console.log("selected:", name)
        setState(currentState => {
            const newState = {...currentState}
            newState.kpiStatus.contents = currentState.kpiStatus.contents.map(status => {
                if (status.kpiInfo.name === name) {
                    return {...status, isSelected: !status.isSelected}
                }
                return status;
            })
            return newState;
        })
    }

    const kpiLists = () => state.kpiStatus.contents.map((info) => {
        const kpiInfo = info.kpiInfo
        return <KpiCard info={info} onKpiSelect={selectKpi} isSelectable={state.isSelectable} key={kpiInfo.id}
                        onStatusChange={changeStatus} authContext={authContext} DeleteKPI={DeleteKPI}/>
    })

    if (state.error) {
        return <ErrorPage description={state.error}/>
    }

    if (state.loading) {
        return <Loader/>
    }

    const getSelectedCount = () => {
        return state.kpiStatus.contents.filter(status => status.isSelected).length;
    }

    const cancelSelections = () => {
        setState(currentState => ({
            ...currentState, isSelectable: false
        }))
    }

    const cloneSelections = () => {
        setOpenCloneModal(true)
    }

    const getSelectedKpiNames = () => {
        return state.kpiStatus.contents
            .filter(status => status.isSelected)
            .map(status => status.kpiInfo.name)
    }


    function SelectableMenu() {
        return <div className={"inline-div"}>
            <p>{getSelectedCount()} KPI's selected</p>
            <Button variant="default" size="xs" onClick={() => cancelSelections()}>
                cancel
            </Button>
            <Button variant="default" size="xs">
                <FontAwesomeIcon onClick={() => cloneSelections()} className={"pointer"} title="Clone" color={"black"}
                                 size={"2x"} icon={faShare}/>
            </Button>
        </div>
    }


    return (
        <div className="kpi-dashboard-container">
            <DashboardOverView>
                <DashboardStatCard title={state.kpiStatus.totalKpis} description={"Total KPI's"} color={"violet"}
                                   icon={faChartSimple}/>
                <DashboardStatCard title={state.kpiStatus.activeKpis} description={"Active KPI's"} color={"grape"}
                                   icon={faChartLine}/>
                <DashboardStatCard title={state.kpiStatus.inactiveKpis} description={"Inactive KPI's"} color={"gray"}
                                   icon={faBan}/>
                <DashboardStatCard title={state.kpiStatus.success} description={"Success"} color={"teal"}
                                   icon={faSquareCheck}/>
                <DashboardStatCard title={state.kpiStatus.failure} description={"Failed"} color={"red"}
                                   icon={faCircleExclamation}/>
            </DashboardOverView>
            <div className={"kpi-card-wrapper"}>
                <div style={{"display": "flex", justifyContent: "space-between"}}>
                    <h2 className={"kpi-cards-title"}>Key Performance Indicators </h2>
                    <div>
                        {!state.isSelectable &&
                        <FontAwesomeIcon onClick={() => enableSelections()} className={"pointer"} title="Clone"
                                         color={"black"} size={"2x"} icon={faArrowUpRightFromSquare}/>}
                        {state.isSelectable && SelectableMenu()}
                    </div>

                </div>
                <div className="kpi-cards">
                    <AddKpiCard/>
                    {state && kpiLists()}
                </div>
                <Modal size="xl" opened={openCloneModal} onClose={() => {
                    setOpenCloneModal(false)
                }}>
                    <CloneKpi kpiNames={getSelectedKpiNames()} close={() => setOpenCloneModal(false)}/>
                </Modal>
            </div>
        </div>
    );

}
